import React from 'react';
import * as PropTypes from 'prop-types';
import Select from '../Select';

const LeadGroupSelect = ({ name, prefix, label, fullWidth, types, disabled }) => {
    const typeOptions = [
        { value: '', label: 'Typ auswählen' },
        ...types.map((type) => ({ value: type, label: type })),
    ];

    return (
        <Select
            options={typeOptions}
            name={name}
            prefix={prefix}
            label={label}
            fullWidth={fullWidth}
            disabled={disabled}
        />
    );
};

LeadGroupSelect.propTypes = {
    name: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
};

LeadGroupSelect.defaultProps = {
    prefix: null,
    label: null,
    fullWidth: false,
    disabled: false,
    types: ['Leadgruppe1', 'Leadgruppe2', 'Leadgruppe3'],
};

export default LeadGroupSelect;
